import React from 'react';

const SettingsHome: React.FC = () => {
    return <h1>SettingsHome</h1>;
};

export default SettingsHome;
